import { FilterHint } from "./local-components/FilterHint/FilterHint.js";
import { IconSortAsc, IconSortDesc } from "@synthesis/shared-icons";
import { jsx } from "react/jsx-runtime";
//#region src/TableFiltersLine/TableSortHint.tsx
const TableSortHint = ({ api, sort }) => {
	const handleClose = () => {
		api.resetColumnState();
	};
	const handleClick = () => {
		const column = api.getColumn(sort.column);
		if (!column) return;
		api.applyColumnState({ state: [{
			colId: sort.column,
			sort: column.getSort() === "asc" ? "desc" : "asc"
		}] });
		api.onSortChanged();
	};
	return /* @__PURE__ */ jsx(FilterHint, {
		icon: sort.sort === "asc" ? /* @__PURE__ */ jsx(IconSortAsc, { className: "size-5" }) : /* @__PURE__ */ jsx(IconSortDesc, { className: "size-5" }),
		label: sort.label,
		value: sort.sort === "asc" ? "по возрастанию" : "по убыванию",
		onClose: handleClose,
		onClick: handleClick
	});
};
//#endregion
export { TableSortHint };

//# sourceMappingURL=TableSortHint.js.map